import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';

const Home = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center bg-gray-50">
      <main className="container p-8 max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-6">
          Heritage Meets Innovation
        </h1>
        <p className="text-xl md:text-2xl text-gray-700 mb-8 max-w-2xl mx-auto">
          Explore modest fashion with confidence. Our AI-powered virtual try-on app helps you find the perfect fit and style, blending cultural heritage with modern technology.
        </p>
        
        <div className="flex justify-center mt-8">
          <Link to="/try-on">
            <Button>
              Start Virtual Try-On
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default Home;